import { render, staticRenderFns } from "./OrganizationalStructure.vue?vue&type=template&id=110f285b&scoped=true&"
import script from "./OrganizationalStructure.vue?vue&type=script&lang=js&"
export * from "./OrganizationalStructure.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationalStructure.vue?vue&type=style&index=0&id=110f285b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f285b",
  null
  
)

export default component.exports